<template>
  <div class="about wpp vssfdvd">
    <h2 class="about_h2">
      <i></i>
      <span>基本信息</span>
    </h2>
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="套餐名称" prop="name">
        <el-input v-model="form.name" maxlength="20"></el-input>
      </el-form-item>
      <!-- <div class="cover">
        <span>封面设计</span>
        <el-upload  :on-change="handleChange" class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p>作为发布内容封面，建议采用比例16:9，大小不超过2M;支持jpg、png格式。如果不填写则设置为默认图</p>
      </div> -->
      <div class="cover">
        <span>封面设计</span>
        <el-upload
          :on-change="handleChange"
          :auto-upload="false"
          class="avatar-uploader"
          action=""
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <!-- <br> -->
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"> -->
            <span style="font-size: 16px;">点击选择封面</span>
          </i>
        </el-upload>
        <p>
          作为发布内容封面，建议采用比例16:9，大小不超过2M;支持jpg、png格式。如果不填写则设置为默认图
        </p>
      </div>
      <el-form-item label="套餐描述" style="width: 400px;">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容，套餐描述最多500字"
          v-model="textarea"
          maxlength="500"
        ></el-input>
      </el-form-item>
      <div class="scale">
        <span style="color: red; margin-right: 3px;">*</span>
        <span>测试量表</span>
        <ul v-if="cscsaa">
          <li>请选择测试量表</li>
        </ul>

        <ul v-for="item in jsonArray" :key="item.message">
          <li>
            <span :title="item.name">{{ item.name }}</span>
            <i @click="del(item.code)" class="el-icon-close"></i>
          </li>
        </ul>
        <el-button
          @click="drawer = true"
          plain
          style="margin-left: 415px; position: absolute; top: 0px; left: 0px;"
        >
          打开量表
        </el-button>
        <el-drawer
          class="scale_right"
          title="我是标题"
          :visible.sync="drawer"
          :with-header="false"
        >
          <div class="scale_right_div">
            <h2>选择量表</h2>
            <span>
              (已选择
              <i>{{ scalenum }}</i>
              条)
            </span>
          </div>
          <el-input
            class="scale_right_input"
            style="
              width: 70% !important;
              margin-left: 20px;
              margin-top: 30px;
              padding-right: 20px;
            "
            v-model="formInline.user"
            placeholder="输入姓名/账号搜索"
          ></el-input>
          <el-button type="primary" @click="query">查询</el-button>
          <div class="scale_list">
            <el-tabs :tab-position="tabPosition">
              <el-tab-pane  class="cvde" style="text-align: left !important;" v-for="item in scalelist" :key="item.message" :label="item.PaperName">
                <el-checkbox-group v-model="checkboxGroup1" v-for="(item, index) in item.LiPaper" :key="index" size="small">
                  <el-checkbox  @change="checkedAllFun" :label="item.PaperCode" :name="item.PaperName">
                    {{ item.PaperName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-tab-pane>
            </el-tabs>
            <!-- <el-button type="primary" @click="scaleqd">确定</el-button> -->
          </div>
        </el-drawer>
      </div>

      <el-form-item class="uyn">
        <el-button v-if="xiugai" type="primary" @click="onSubmit('form')">
          立即创建
        </el-button>
        <el-button v-else type="primary" @click="onSub">立即修改</el-button>
        <el-button @click="this.$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textarea: '',
      Back_num: '',
      drawer: false,
      drawer0: false,
      xiugai: true,
      uny: false,
      scalenum: '0',
      cscsaa: true,
      scalelist: '',
      checkboxGroup1: [],
      chec: {},
      tabPosition: 'left',
      imageUrl: '',
      file: '',
      radio: 1,
      value1: '',
      times: '',
      jsonArray: [],
      formInline: {
        user: '',
      },
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      form: {
        name: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
      },
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      },
    }
  },
  beforeCreate() {
    this.$Http_Post('ScaleIssue/GetShowScale', {Tiaojian: '',}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.scalelist = res.Data
      } else {
        this.$message({
          type: 'success',
          message: '数据加载异常！',
        })
      }
    })
  },
  methods: {
    handleChange(file, fileList) {},
    query() {
      this.$http({
        method: 'post',
        url: 'ScaleIssue/GetShowScale',
        data: {
          item: this.$cookies.get('token'),
          Tiaojian: this.formInline.user,
        },
      }).then((res) => {
        if (res.data.Code == 200) {
          this.scalelist = res.data.Data
        }
      })
    },
    del(code) {
      var slist = this.checkboxGroup1
      var i = 0
      for (i = 0; i < slist.length; i++) {
        if (slist[i] == code) {
          slist.splice(i, 1)
        }
      }
      var ss = this.jsonArray
      var ii = 0
      for (ii = 0; ii < ss.length; ii++) {
        if (ss[ii].code == code) {
          ss.splice(ii, 1)
        }
      }
    },
    getCheckedKeys() {},
    checkedAllFun(string, number, boolean) {
      if (string) {
        var uncs = {}
        uncs.name = number.target.name
        uncs.code = number.target.value
        this.jsonArray.push(uncs)
        this.cscsaa = false
      } else {
        var ss = this.jsonArray
        var i = 0
        for (i = 0; i < ss.length; i++) {
          if (ss[i].name == number.target.name) {
            ss.splice(i, 1)
          }
        }
      }
      this.scalenum = this.checkboxGroup1.length
    },
    scaleqd() {},
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var from = new FormData()
          from.append('SetMealName', this.form.name)
          from.append('fbCover', this.file.raw)
          from.append('PaperS', this.checkboxGroup1)
          from.append('DescribeS', this.textarea)
          this.$Http_Post('ScaleIssue/AddPaperSetmeal', from, {'Content-Type': 'multipart/form-data',}).then((res) => {
            this.$notify.closeAll();
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message)
              this.$router.go(-1)
            } else {
              this.$message({
                type: 'success',
                message: res.Message,
              })
            }
          })
        } else {
          return false
        }
      })
      let item = {}
    },
    onSub() {
      let item = {}
      item.SetMealName = this.form.name
      item.CoverUrl = ''
      item.PaperS = this.checkboxGroup1
      item.DescribeS = this.textarea
      this.$http({method: 'post',url: 'ScaleIssue/AddPaperSetmeal',data: { token: this.$cookies.get('token'), item: item },}).then((res) => {
        if (res.data.Code == 200) {
          this.Global.request_successful(res.Message)
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    open() {
      this.$notify.success({
        title: 'Info',
        message: '这是一条没有关闭按钮的消息',
        showClose: false,
      })
    },
    chooseTimeRange(t) {
      this.times = t
    },
    agreeChange(e) {
      if (this.radio == 2) {
        this.s_time = true
      } else {
        this.s_time = false
      }
    },
    handleChange(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.file = file
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  },
  created() {//判断地址是否带参数
    this.Back_num = this.$route.query.param
    if (this.$route.query.param == 'm') {
      this.jsonArray = JSON.parse(sessionStorage.getItem('jsonArray'))
      this.checkboxGroup1 = sessionStorage.getItem('checkboxGroup1').split(',')
    } else {
      sessionStorage.setItem('checkboxGroup1', '')
      sessionStorage.setItem('jsonArray', '')
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/download/data_downlaod') {
        vm.insertUrl =
          insertProUrl + '/html/resource/user-center.html?type=approval'
      }
    })
  },
  mounted() {
    if (this.jsonArray.length >= 1) {
      this.cscsaa = false
    } else {
      this.cscsaa = true
    }
  },
}
</script>
<style>
.about {border: 1px solid #e7e7e7;min-height: 95%;padding: 16px;position: relative;background-color: #fff;}
.about_h2 {font-size: 16px;position: relative;}
.about_h2 span {position: absolute;top: 0px;left: 8px;}
.about_h2_t {font-size: 16px;position: relative;margin-top: 50px;}
.about_h2_t span {position: absolute;top: 0px;left: 8px;}
.about_h2_t i {height: 20px;width: 3px;background-color: rgba(42, 143, 232, 1);display: inline-block;}
.about_h2 i {height: 20px;width: 3px;background-color: rgba(42, 143, 232, 1);display: inline-block;}
.wpp .el-form .el-input {width: 218px !important;}
.wpp form {margin-top: 30px;}
.wpp .el-form-item__content {position: relative;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover {border-color: #409eff;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 250px;}
.avatar-uploader {position: absolute;top: 0px;left: 70px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.scale {margin-top: 30px;}
.scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;}
.scale ul,.scale0 ul {width: 200px;}
.scale > ul,.scale0 > ul {padding: 5px 12px;width: 298px;background-color: rgba(235, 235, 235, 1);border-radius: 2px;margin-top: -20px;margin-left: 72px;}
.scale > ul li,.scale0 > ul li {background-color: #fff;height: 40px;line-height: 40px;text-align: left;margin-top: 8px;margin-bottom: 8px;position: relative;text-indent: 10px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;position: relative;}
.scale > ul li span,.scale0 > ul li span {width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inherit;}
.scale > ul li i,.scale0 > ul li i {float: right;margin-right: 14px;margin-top: 14px;position: absolute;right: -4px;top: 0px;}
.set_time > span {font-size: 14px;color: #606266;margin-left: 16px;padding-top: 14px;display: inline-block;}
.set_time .block {margin-top: -28px;margin-left: 83px;}
.set_time .el-radio {float: left;margin-top: 20px;}
.se_time {position: relative;}
.el-radio-group {margin-left: 80px;margin-top: 0px;}
.time_picker {position: absolute;top: 44px;left: 172px;}
.scale_list {height: calc(100% - 130px);}
.scale_list > ul {margin-left: 20px;margin-top: 200px;position: relative;}
.scale_list > ul > li {height: 40px;width: 140px;line-height: 40px;text-align: left;}
.scale_list > ul > li ul {position: absolute;left: 200px;}
.scale_right h2 {font-size: 18px;margin-left: 20px;margin-top: 30px;display: inline-block;}
.scale_right_div span {color: rgba(0, 136, 255, 1);margin-left: 10px;}
.scale_right_div i {font-style: normal;}
.scale_right_div .scale_right_input {margin-left: 20px;margin-top: 40px;width: 180px !important;padding-right: 20px;}
.scale .scale_list {margin-top: 20px;}
.scale .el-tabs--left .el-tabs__item.is-left {text-align: left !important;}
.vssfdvd .cvde .el-checkbox {width: 300px;margin-top: 20px;}
.vssfdvd .uyn {margin-top: 50px;}
.vssfdvd .avatar-uploader-icon {background-color: rgb(239 239 239);}
.vssfdvd .el-textarea__inner {background-color: rgb(239 239 239);}.vssfdvd .el-tabs__header {width: 40% !important;}
</style>
